/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Save search button component
 */

import { ClearButton } from '@zcode-ui/controls'
import { bellFilled, bellOutline } from '@zcode-ui/icons'
import { saveSearchBtn } from './style'

export interface SaveSearchButtonProps {
  isSavedSearch: boolean
  onClick: () => void
}

export const SaveSearchButtonMobile = ({ isSavedSearch, onClick }: SaveSearchButtonProps) => {
  return (
    <ClearButton aria-label="save search" css={saveSearchBtn} onClick={onClick}>
      {isSavedSearch ? (
        <img alt="search is already saved" src={bellFilled} />
      ) : (
        <img alt="search is not yet saved" src={bellOutline} />
      )}
    </ClearButton>
  )
}
